'use strict';

function noop() {}

module.exports = noop;


/** WEBPACK FOOTER **
 ** ./utils/noop.js
 **/